import { render, staticRenderFns } from "./SmallLoginModal.vue?vue&type=template&id=29ff5b90&"
import script from "./SmallLoginModal.vue?vue&type=script&lang=js&"
export * from "./SmallLoginModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports